import { render, staticRenderFns } from "./showData.vue?vue&type=template&id=c4fffc90&scoped=true&"
import script from "./showData.vue?vue&type=script&lang=js&"
export * from "./showData.vue?vue&type=script&lang=js&"
import style0 from "./showData.vue?vue&type=style&index=0&id=c4fffc90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4fffc90",
  null
  
)

export default component.exports